export default __webpack_public_path__ + "static/media/acquisition.fd73e574.svg";